'use client'

import { useEffect, useState } from 'react'
import { getCookie } from '@/app/lib/utils'

const APP_COOKIE_NAME = 'eciAppVersion'
const APP_COOKIE_VALUE = 'eci-app-focus'

/**
 * `true` cuando el sitio se abre dentro de la vista de la app (cookie
 * `eciAppVersion=eci-app-focus`). `false` por defecto en servidor y en el
 * primer render de cliente (coinciden, sin *hydration mismatch* — mismo
 * patrón que `FooterVisibilityGate`), corregido tras el montaje.
 *
 * Deliberadamente NO se resuelve con `cookies()` de servidor: forzaría
 * *dynamic rendering* en cualquier página que muestre un precio, rompiendo
 * ISR (Constitution Principio I — ver
 * specs/016-precios-descuentos-promociones/research.md §1).
 */
export function useAppPromotionCookie(): boolean {
  const [isAppContext, setIsAppContext] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- lectura de cookie post-hidratación, ver architecture.rule.md
    setIsAppContext(getCookie(APP_COOKIE_NAME) === APP_COOKIE_VALUE)
  }, [])

  return isAppContext
}
